import { render, staticRenderFns } from "./StreakEventBar.vue?vue&type=template&id=0f2804e4&"
import script from "./StreakEventBar.vue?vue&type=script&lang=ts&"
export * from "./StreakEventBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports